export default {
  namespace: true,
  state: {
    activityHomeList: null,
  },
  mutations: {
    setactivityHomeList(state, activityHomeList) {
      state.activityHomeList = activityHomeList
    }
  },
  actions: {
    getActivityHomeList({commit}, activityHomeList) {
      return new Promise(resolve => {
        commit('setactivityHomeList', activityHomeList)
        resolve(activityHomeList)
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/activity.js